import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderComponent implements OnInit {
  @Input() variant?: string;
  constructor() {}

  ngOnInit() {}
}
